import { useScrollReveal } from '@/hooks/useScrollReveal';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Secure Gated Community',
    desc: '24/7 security with controlled entry points ensuring complete peace of mind for residents and investors.',
  },
  {
    icon: 'ri-plant-line',
    title: 'Green & Peaceful Environment',
    desc: 'Lush landscaping, tree-lined avenues, and dedicated green spaces that create a serene living atmosphere.',
  },
  {
    icon: 'ri-road-map-line',
    title: 'Wide Carpeted Roads',
    desc: 'Spacious road infrastructure designed for smooth traffic flow with proper drainage and street lighting.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Modern Infrastructure',
    desc: 'Underground utilities, fiber-optic connectivity, and modern urban planning standards throughout.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'High Investment Potential',
    desc: 'Strategic location in a rapidly appreciating zone with proven year-over-year value growth.',
  },
  {
    icon: 'ri-team-line',
    title: 'Community Living',
    desc: 'Family-oriented planning with parks, mosques, schools, and commercial areas within walking distance.',
  },
];

export default function KeyFeatures() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className="w-full py-16 md:py-24 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-16">
        <div className={`text-center mb-12 md:mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-[11px] font-bold text-[#d4853a] uppercase tracking-[0.2em] mb-3">
            What Makes It Special
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-[2.25rem] font-extrabold text-charcoal-300 leading-tight mb-4">
            Key <span className="text-[#d4853a]">Features</span>
          </h2>
          <p className="text-[15px] text-charcoal-50 max-w-xl mx-auto leading-relaxed">
            Every detail crafted to deliver a premium living and investment experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, i) => (
            <div
              key={feature.title}
              className={`group relative bg-white rounded-2xl p-6 md:p-8 border border-ivory-200 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_16px_48px_rgba(0,0,0,0.06)] hover:border-[#d4853a]/15 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: isVisible ? `${i * 100}ms` : '0ms' }}
            >
              {/* Hover accent bar */}
              <div className="absolute top-0 left-6 right-6 h-[3px] bg-[#d4853a] rounded-b-full opacity-0 transition-all duration-300 group-hover:opacity-100" />

              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#d4853a]/8 text-[#d4853a] mb-5 transition-all duration-300 group-hover:bg-[#d4853a] group-hover:text-white group-hover:shadow-lg group-hover:shadow-[#d4853a]/20">
                <i className={`${feature.icon} text-xl`} />
              </div>

              <h3 className="text-base font-bold text-charcoal-300 mb-2">{feature.title}</h3>
              <p className="text-[13px] text-charcoal-50 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}